module.exports = __webpack_public_path__ + "img/conf_mail_todolist.b11ef446.png";